@for (awb of awbs; let awbIndex = $index; track awbIndex) {
    <div [class.mt-2]="awbIndex > 0">
        <app-lib-awb [awb]="awb" />
    </div>
}
<button
    id="add-more-awbs-btn"
    matButton="outlined"
    appMatStrokedButtonBorder
    type="button"
    color="primary"
    (click)="addMoreItems()"
    class="mt-3 w-100"
>
    ADD MORE AWBS
</button>
